import { render, staticRenderFns } from "./DishDetailSheet.vue?vue&type=template&id=d9f79ec2&scoped=true"
import script from "./DishDetailSheet.vue?vue&type=script&lang=js"
export * from "./DishDetailSheet.vue?vue&type=script&lang=js"
import style0 from "./DishDetailSheet.vue?vue&type=style&index=0&id=d9f79ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f79ec2",
  null
  
)

export default component.exports